import { render, staticRenderFns } from "./goodsSelectComponent.vue?vue&type=template&id=6661cdaa&"
import script from "./goodsSelectComponent.vue?vue&type=script&lang=js&"
export * from "./goodsSelectComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/admin_admin-web_uLO7/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6661cdaa')) {
      api.createRecord('6661cdaa', component.options)
    } else {
      api.reload('6661cdaa', component.options)
    }
    module.hot.accept("./goodsSelectComponent.vue?vue&type=template&id=6661cdaa&", function () {
      api.rerender('6661cdaa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/bianlidianManage/onlineshop/goodsSelectComponent.vue"
export default component.exports